import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { AddressSectionContent } from 'common';
import { fetchAddressSection } from './AddressSectionSlice';
import { AddressSectionContentSelector } from './AddressSectionContentSelector';

export function useAddressSection(): AbstractContentState<AddressSectionContent> {
    return useCmsContent(fetchAddressSection, AddressSectionContentSelector);
}
